import napStyles from './../nap.json'

export default {
  name: 'B3',
  type: 'Heading',
  color: napStyles.colors.PrimaryBlack
}
